export default __webpack_public_path__ + "assets/wind-beaufort-3.8da80a53.svg";